export const SERVER_URL = `${process.env.REACT_APP_SERVER || ''}/api/v1`;


// WEBPACK FOOTER //
// ./src/Config/apiConfig.ts